import { useMemo } from "react";
import { matchPath, useLocation } from "react-router-dom";
import { rootNavigationPageConfig } from "../root-config";
import { PageNavConfig } from "../types/PageNavConfig";
import { getEntityPagePath } from "../utils/getEntityPagePath";

export const useCurrentPageNavConfig = (): PageNavConfig | undefined => {
  const { pathname } = useLocation();

  return useMemo(() => {
    const configs = Object.values(rootNavigationPageConfig);
    return configs.find((config) => {
      const fullPath =
        config.isPrivate && !config.isEntityOptional
          ? getEntityPagePath(config.path)
          : config.path;
      return matchPath(fullPath, pathname);
    });
  }, [pathname]);
};
